import { render, staticRenderFns } from "./EditAttributeDialog.vue?vue&type=template&id=3c6c58e2&scoped=true"
import script from "./EditAttributeDialog.vue?vue&type=script&lang=js"
export * from "./EditAttributeDialog.vue?vue&type=script&lang=js"
import style0 from "./EditAttributeDialog.vue?vue&type=style&index=0&id=3c6c58e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6c58e2",
  null
  
)

export default component.exports